import React from 'react';

const DebugTest = () => {
  console.log('DebugTest component is rendering');
  
  return (
    <div style={{ 
      padding: '20px', 
      backgroundColor: '#f0f0f0',
      minHeight: '100vh',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1 style={{ color: '#333', marginBottom: '20px' }}>Debug Test Page</h1>
      <p style={{ color: '#666', marginBottom: '10px' }}>If you can see this, React is working!</p>
      <p style={{ color: '#666', marginBottom: '10px' }}>Current time: {new Date().toLocaleString()}</p>
      <p style={{ color: '#666', marginBottom: '10px' }}>User Agent: {navigator.userAgent}</p>
      <p style={{ color: '#666', marginBottom: '10px' }}>Window location: {window.location.href}</p>
      <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#e0e0e0', borderRadius: '5px' }}>
        <h3 style={{ color: '#333', marginBottom: '10px' }}>Environment Check:</h3>
        <p style={{ color: '#666', marginBottom: '5px' }}>NODE_ENV: {import.meta.env.MODE}</p>
        <p style={{ color: '#666', marginBottom: '5px' }}>VITE_SUPABASE_URL: {import.meta.env.VITE_SUPABASE_URL ? 'Set' : 'Not set'}</p>
        <p style={{ color: '#666', marginBottom: '5px' }}>VITE_BLS_API_KEY: {import.meta.env.VITE_BLS_API_KEY ? 'Set' : 'Not set'}</p>
        <p style={{ color: '#666', marginBottom: '5px' }}>VITE_ONET_API_KEY: {import.meta.env.VITE_ONET_API_KEY ? 'Set' : 'Not set'}</p>
        <p style={{ color: '#666', marginBottom: '5px' }}>VITE_ONET_CLIENT_ID: {import.meta.env.VITE_ONET_CLIENT_ID ? 'Set' : 'Not set'}</p>
      </div>
    </div>
  );
};

export default DebugTest;
